import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
// import { useParams } from 'react-router-dom';

export const useInvestorPropertyDetail = (propertyId: string, type: string) => {
  const axios = useAxios(type);
  const { t } = useTranslation();
  const urlKey = `${t("investor-property-detail")}?key=${propertyId}`;

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["investor-Property-Detail", propertyId],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      return res?.data;
    },
    refetchOnMount: true,
    enabled: !!propertyId && type !== "internal-investor"
  });

  return { data: data?.data, isLoading, isFetching, refetch };
};
